<template>
  <div class="reason-cell">
    <z-radio-group v-model="radio">
    <z-cell-group>
      <z-cell v-for="(item,index) in cellList" :key="index"
        @click="reasonClick(item)"
        :is-link="true"
      >
        <!--原因title, 根据level展示不同样式-->
        <span slot="title" :class="[isFirstLevel(item) ? 'level-one' : 'other-level']">{{item.reason}}</span>
        <!--辅助提示一级二级时展示-->
        <span v-if="!item.isLeaf || (item.level == 1 || item.level == 2) " slot="label">{{item.notice}}</span>
        <!--勾选-->
        <!-- <z-radio :name="item.reasonId" v-if="!isFirstLevel(item)"/> -->
      </z-cell>
    </z-cell-group>
    </z-radio-group>
  </div>
</template>
<script>
import { Cell, CellGroup, RadioGroup } from '@zz-common/zz-ui';
export default {
  name: 'reasonCell',
  components: {
    'z-cell': Cell,
    'z-cell-group': CellGroup,
    'z-radio-group': RadioGroup
  },
  props: {
    cellList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      radio: ''
    }
  },
  computed: {
    //是否是一级原因
    isFirstLevel() {
      return function(item) {
        return item.level == 1
      }
    }
  },
  methods: {
    //原因点击向外触发点击事件
    reasonClick(item) {
      this.$emit('cellClick', item)
      if (item.level !== 1) {
        this.radio = item.reasonId
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>